import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import styles from '../style';
import { withRouter } from 'react-router-dom';
import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Modal,
  TextField,
  Button,
  Tooltip
} from '@material-ui/core';
import moment from 'moment';
import { connect } from 'react-redux';
import empty from '../../../assets/images/empty.svg';
import { getAllPhyPtSchedulesWeekly } from 'services/ptschedules/action';
import { Calendar, momentLocalizer, Navigate } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { CircularProgress } from '@material-ui/core';

const PTList = props => {
  const localizer = momentLocalizer(moment);
  const {
    classes,
    data,
    setFormstate,
    setSelecteddate,
    isfromScheduleAppointment,
    scheduleBtn,
    seldate,
    ehrID,
    locations,
    providers,
    filtervals
  } = props;

  const [ptScheduleList, setPtScheduleList] = useState(null);
  const [, setTimeFrom] = useState(null);
  const [duration, setDuration] = useState(null);
  const [slots, setSlots] = useState(null);
  const [openQV, setOpenQV] = React.useState({ showQV: false, item: null });
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [locs, setLocs] = useState([]);
  const [pros, setPros] = useState([]);
  const [currentDate, setCurrentDate] = useState(
    seldate ? new Date(seldate) : new Date()
  );

  const [filtervalues, setFilterValues] = useState({});

  const handleOpenQV = (e, item) => {
    e.stopPropagation();
    setOpenQV({ showQV: true, item: item });
  };

  const handleCloseQV = () => {
    setOpenQV({ showQV: false });
  };

  const loadInitialData = async () => {
    await loadTimeSlots();
    await loadDuration();
    await loadHours();
  };

  useEffect(() => {
    if (data) {
      loadInitialData();
    }
  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      setEvents(mapToEvents(data));
    } else {
      setEvents([]);
    }
  }, [data, seldate]);

  useEffect(() => {
    if (seldate) {
      setCurrentDate(seldate ? new Date(seldate) : new Date());
    }
  }, [seldate])

  useEffect(() => {
    if (filtervals) {
      setFilterValues({
        location: filtervals.location,
        provider: filtervals.provider
      });
    }
  }, [filtervals]);

  const loadTimeSlots = () => {
    let time = [{ key: 'From', value: '' }];
    for (let i = 480; i <= 1380; i += 15) {
      let hours, minutes, ampm;
      hours = Math.floor(i / 60);
      minutes = i % 60;
      if (minutes < 10) {
        minutes = '0' + minutes; // adding leading zero
      }
      ampm = hours % 24 < 12 ? 'AM' : 'PM';
      hours = hours % 12;
      if (hours === 0) {
        hours = 12;
      }
      let slot = hours + ':' + minutes + ' ' + ampm;
      time.push({ key: slot, value: slot });
    }
    setTimeFrom(time);
  };

  const loadDuration = () => {
    let duration = [];
    let durations = ['15', '30', '45', '60'];
    for (let i = 0; i < durations.length; i++) {
      duration.push({
        key: durations[i] + ' min',
        value: durations[i] + ' min'
      });
    }
    setDuration(duration);
  };

  const loadHours = () => {
    let time = [];
    let hours, ampm;

    for (let i = 60; i <= 1380; i += 60) {
      hours = Math.floor(i / 60);
      ampm = hours < 12 ? ' AM' : ' PM';
      hours = hours % 12;
      if (hours === 0) {
        hours = 12;
      }
      let slot = hours + ampm;
      time.push({ key: slot, value: slot });
    }
    setSlots(time);
  };

  const mapToEvents = (data = []) =>
    data.map(item => ({
      id: item.id, // or any unique key
      title: `${item.patientName || ''}${item.routePhysicianName ? ', ' + item.routePhysicianName : ''
        }`,
      start: new Date(item.timeFrom),
      end: new Date(item.timeTo),
      resource: item, // keep full object for quick view
    }));

  const handleEditAppointment = item => {
    setOpenQV({ showQV: false });
    props.handleEditAppointment(item);
  };

  const handleDeleteAppointment = item => {
    setOpenQV({ showQV: false });
    props.handleDeleteAppointment(item);
  };

  const handleOpenScheduleAppointment = e => {
    e.stopPropagation();
    props.handleOpenScheduleAppointment();
  };

  //For home page Schedule

  useEffect(() => {
    if (locations != undefined) {
      let locationtopush = [];
      locationtopush.push({ key: 'All Locations', value: '' });
      locations.forEach(function (item) {
        locationtopush.push({
          value: item.id,
          key:
            (item.companyname !== null ? item.companyname : '') +
            ',' +
            (item.address && item.address.address ? item.address.address : '')
        });
      });
      setLocs(locationtopush);
    }
  }, [locations]);

  useEffect(() => {
    if (providers != undefined) {
      let providertopush = [];
      providertopush.push({ key: 'All Providers', value: '' });
      providers.forEach(function (item) {
        providertopush.push({
          value: item.id,
          key:
            (item.firstname ? item.firstname : '') +
            (item.lastname ? ' ' + item.lastname : '') +
            (item.title ? ' ' + item.title : '')
        });
      });
      setPros(providertopush);
    }
  }, [providers]);

  const handleDrpDownChange = (field, value) => {
    const newState = { ...filtervalues };
    let location, provider;
    if (field === 'location') {
      location = value;
    } else {
      location = newState.location;
    }
    if (field === 'provider') {
      provider = value;
    } else {
      provider = newState.provider;
    }
    setFilterValues({ ...filtervalues, [field]: value });
    props.handleDrpDownChange(location, provider);
  };

  const nowScrollTime = React.useMemo(
    () => {
      const d = new Date();
      return new Date(1970, 0, 1, d.getHours(), d.getMinutes(), 0, 0);
    },
    [] // create once on mount
  );

  // 1) Precompute overlapping event ids
  const getOverlappingIds = events => {
    const overlaps = new Set();

    for (let i = 0; i < events.length; i++) {
      const a = events[i];
      const aStart = new Date(a.start);
      const aEnd = new Date(a.end || a.start);

      for (let j = i + 1; j < events.length; j++) {
        const b = events[j];
        const bStart = new Date(b.start);
        const bEnd = new Date(b.end || b.start);

        const isOverlap =
          aEnd > bStart && aStart < bEnd; // standard interval overlap check[web:26]

        if (isOverlap) {
          overlaps.add(a.id);
          overlaps.add(b.id);
        }
      }
    }

    return overlaps;
  };

  const overlappingIds = React.useMemo(
    () => getOverlappingIds(events),
    [events]
  );

  // 2) Use in eventPropGetter
  const eventPropGetter = event => {
    const now = new Date();
    const isPast = new Date(event.end || event.start) < now;

    const isOverlapping = overlappingIds.has(event.id);

    const bg = isOverlapping
      ? '#F9EEEE'          // overlapping
      : isPast
        ? '#f1f1f1'        // past
        : '#ACE1CE';       // normal
    const borderColor = isOverlapping
      ? '#EFD5D5'          // overlapping
      : isPast
        ? '#c8c8c8'        // past
        : '#94CFBA';

    return {
      style: {
        borderRadius: '4px',
        borderColor: borderColor,
        backgroundColor: bg,
        opacity: isPast ? 0.6 : 1,
        pointerEvents: 'none',
        color: 'rgba(0,0,0,.6)',
      },
    };
  };

  const fetchWeeklyEvents = async (start, end) => {
    setLoading(true)
    // example: format as yyyy-MM-dd or ISO for your backend
    const startDate = moment(start).format('MM/DD/YYYY');
    const endDate = moment(end).format('MM/DD/YYYY');
    const res = await props.getAllPhyPtSchedulesWeekly(
      ehrID,
      startDate,
      endDate);
    // adapt to your actual action/response shape
    setEvents(mapToEvents(res || []));
    setLoading(false)
  };

  const handleRangeChange = async (range, view) => {
    // week / work_week => range is [Date, ..., Date] for each day
    if (Array.isArray(range) && range.length) {
      const start = range[0];                  // first day in week
      const end = range[range.length - 1];     // last day in week

      // call your API here with start/end
      await fetchWeeklyEvents(start, end);
    }
  };

  const EventComponent = ({ event }) => {
    const isOtherUser = event?.resource?.patientId !== props?.profile?.userID;
    return ( <span title={isOtherUser ? "Not available" : event.title}>
        {isOtherUser ? "- Not available" : event.title}
      </span> 
    );
  };

  return (
    <>
      {scheduleBtn ? (
        <Box className={classes.PTfilterWrap} style={{ padding: 10 }}>
          <Box className={classes.PTfilterLeft}>
            <TextField
              InputLabelProps={{ shrink: true }}
              name="Title"
              onChange={event =>
                handleDrpDownChange('location', event.target.value)
              }
              select
              SelectProps={{ native: true }}
              style={{ maxWidth: 150 }}
              value={filtervalues.location || ''}
              variant="outlined">
              {locs &&
                locs.map(item => (
                  <option value={item.value}>{item.key}</option>
                ))}
            </TextField>
            &nbsp;
            <TextField
              name="Title"
              onChange={event =>
                handleDrpDownChange('provider', event.target.value)
              }
              select
              SelectProps={{ native: true }}
              style={{ maxWidth: 125 }}
              value={filtervalues.provider || ''}
              variant="outlined">
              {pros &&
                pros.map(item => (
                  <option value={item.value}>{item.key}</option>
                ))}
            </TextField>
          </Box>
          <Box className={classes.PTfilterRight}>
            <Button
              color="primary"
              onClick={props.handleOpenScheduleAppointment}
              size="small"
              style={{ fontSize: 11, height: 32 }}
              variant="contained">
              Schedule Appointment
            </Button>
          </Box>
        </Box>
      ) : null}
      <React.Fragment>
        <Calendar
          localizer={localizer}
          events={events}
          defaultView="day"
          views={['day']}
          date={currentDate}
          scrollToTime={nowScrollTime}
          step={15}
          timeslots={4} // 4 * 15 = 60 minutes per big cell
          style={{ height: 600 }}
          onRangeChange={handleRangeChange}
          onNavigate={newDate => {              // update state when toolbar navigates
            setCurrentDate(newDate);
            setSelecteddate && setSelecteddate(newDate);
            setFormstate && setFormstate(prev => ({ ...prev, appointmentDate: newDate }));
            // if you also want to inform parent:
            // props.onDateChange && props.onDateChange(newDate);
          }}
          eventPropGetter={eventPropGetter}
          components={
            { event: EventComponent }
          }
        />
        {loading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              backgroundColor: 'rgba(151, 151, 151, 0.4)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10,
            }}
          >
            {/* MUI */}
            {/* <CircularProgress color="inherit" /> */}
            <CircularProgress size={30} color="inherit" />
          </div>
        )}
      </React.Fragment>
    </>
  );
};

PTList.propTypes = {
  className: PropTypes.string
};

const mapDispatchToProps = { getAllPhyPtSchedulesWeekly };

const mapStateToProps = state => ({
  ehrID: state.profile && state.profile.ehrID,
  profile: state.profile
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PTList))
);
